import { Col, Drawer, Row } from "antd";

import TopImportantFilters from "./TopImportantFilters";
import Sorting from "./Sorting";
import { MazakaButton } from "apps/Common/MazakaButton";
import { FilterOutlined } from "@ant-design/icons";
import { useState } from "react";

const TopOptions = () => {
  const [isShowMobileDrawerFilter, setIsShowMobileDrawerFilter] =
    useState(false);
  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Row gutter={[0, 20]}>
            <Col xs={24} xl={16} >
              <div className="!hidden md:!block">
                <TopImportantFilters isUseLabel={false} setIsShowMobileDrawerFilter={setIsShowMobileDrawerFilter} />
              </div>
              <div className="!block md:!hidden">
                <MazakaButton
                  className="!bg-black !text-white"
                  icon={<FilterOutlined />}
                  block
                  onClick={() => {
                    setIsShowMobileDrawerFilter(true);
                  }}
                >
                  Filtre
                </MazakaButton>
              </div>
            </Col>
            <Col
              xs={24}
              
              xl={8}
         
              className="!flex justify-end   hover:cursor-pointer  "
            >
              <Col
              xs={24}
              sm={10}
              lg={12}
              
              >
              <Sorting />
              </Col>

          
            </Col>
          </Row>
        </Col>
      </Row>
      <Drawer
      open={isShowMobileDrawerFilter}
      onClose={()=>{
        setIsShowMobileDrawerFilter(false)
      }}
      title={"Haberleri Filtrele"}
      >
        <TopImportantFilters isUseLabel={true} setIsShowMobileDrawerFilter={setIsShowMobileDrawerFilter} />
      </Drawer>
    </>
  );
};

export default TopOptions;
